import { useNavigate } from 'react-router-dom';
import Loading from '../components/base/Loading';
import { useGetAlbumsQuery } from '../graphql/schema';

const Albums = () => {
  const navigate = useNavigate();

  const { data, loading } = useGetAlbumsQuery();

  if (loading) return <Loading />;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {data?.albums.items.map((album) => (
        <div
          key={album.id}
          className="rounded-lg bg-gray-200 p-5 text-lg cursor-pointer"
          onClick={() => {
            navigate(`/album/${album.slug}`);
          }}
        >
          {album.name}
        </div>
      ))}
    </div>
  );
};

export default Albums;
